"use client"

import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import '@/src/extensions/number'
import CategorySectionHeader from '../category-section-header/category-section-header'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import { useCategory } from '@/src/context/category/category-context'
import ImageFallback from '@/src/components/helpers/image-fallback/image-fallback'
import ScrollContent from '@/src/components/helpers/scroll-content/scroll-content'
import LoadingPromotions from './loading-promotions/loading-promotions'
import Items from '@/src/interfaces/catalog/items'
import { usePromotion } from '@/src/context/promotion/promotion-context'
import { PromotionHelper } from '@/src/helpers/promotion'
import FullProduct from '../../../full-product/full-product'
import { useAppAccessToken } from '@/src/context/app-access-token/app-access-token-context'
import CacheHandler from '@/src/core/cache/cache-handler'

interface Props {
    title: string
}

export default function Promotions(props: Props) {
    const [loading, setLoading] = useState<boolean>(true)
    const { categoriesBySearch } = useCategory()
    const { merchantSummary, localMode } = useMerchant()
    const { promotion, setPromotion, setCanShowPromotion, canShowPromotion } = usePromotion()
    const { appAccessToken } = useAppAccessToken()

    const [products, setProducts] = useState<Items.ItemResponse[]>()

    const [product, setProduct] = useState<Items.ItemResponse>()
    const [modalProduct, setModalProduct] = useState(false)

    const handleCardClick = (p: Items.ItemResponse) => {
        setProduct(p)
        setModalProduct(true)
    }

    const handleModalClose = () => {
        setModalProduct(false)
        setProduct(undefined)
    }

    useEffect(() => {
        const fetchPromotions = async () => {
            try {
                setLoading(true)

                const promotionsResponse = await PromotionHelper.fetchPromotions(merchantSummary?.id!, 6, localMode, appAccessToken)

                if (!promotionsResponse)
                    return

                setPromotion(promotionsResponse)

                const idsList = PromotionHelper.getProductsIds(promotionsResponse)

                if (idsList.length < 1)
                    return

                const productsResponse = await CacheHandler.getListItems(merchantSummary?.id!, idsList, !!localMode, appAccessToken)

                if (!productsResponse)
                    return

                setProducts(productsResponse)

                const promo = promotionsResponse

                if (promo.showPromotions && (promo.promotions && promo.promotions.length > 0) && (productsResponse.length > 0)) {
                    setCanShowPromotion(true)
                }
            }
            finally {
                setLoading(false)
            }
        }

        if (!products && merchantSummary)
            fetchPromotions()
    }, [merchantSummary])

    if (loading)
        return <LoadingPromotions />

    if (!loading && (!products || !promotion || (categoriesBySearch?.categories && categoriesBySearch.categories.length > 0)))
        return <></>

    if (categoriesBySearch?.categories && categoriesBySearch.categories.length < 1)
        return <></>

    if (!canShowPromotion)
        return <></>

    return (
        <>
            {
                (modalProduct && product) &&
                <FullProduct
                    product={product}
                    isOpen={modalProduct}
                    onClose={handleModalClose}
                />
            }
            <section className={styles.container}>
                <CategorySectionHeader id={'promocoes'} title={props.title} type={'promotions'} />
                <ScrollContent>
                    {
                        products && products.map((item, index) => {
                            const from = PromotionHelper.getFromToPrice(promotion, item).from.toLocalePrice()
                            const to = PromotionHelper.getFromToPrice(promotion, item).to.toLocalePrice()
                            const imgSrc = (item.hasPhoto && merchantSummary?.showProductPhoto) ? `//${item?.smallImageUrl}` : undefined

                            return (
                                <div key={index} onClick={() => handleCardClick(item)} className={styles.card}>
                                    <div className={styles.imageArea}>
                                        <ImageFallback
                                            className={styles.itemPromotionImage}
                                            src={imgSrc}
                                            alt={item.name}
                                        />
                                    </div>
                                    <div className={styles.contentDescription}>
                                        <span data-testid='promotion-identify' className={`${styles.label} font-xsm`}>{PromotionHelper.getDisplayLabel(item, promotion)}</span>
                                        <b className={`${styles.title} font-md`} data-testid="item-title">{item.name}</b>
                                        <p className={`${styles.description} font-sm`}>{merchantSummary?.showProductDescription ? item.description : ''}</p>
                                        {
                                            (merchantSummary?.showProductPrice)
                                                ? PromotionHelper.getFromToPrice(promotion, item).to <= 0
                                                    ? <b className={`${styles.price} font-sm`}>{from}</b>
                                                    : <span className={`${styles.from} ${styles.price}`}><label>De <s>{from}</s> por </label><b>{to}</b></span>
                                                : <p></p>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </ScrollContent>
            </section>
        </>
    )
}
